import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useNavigate, Navigate } from "react-router-dom";
import ReactImageFallback from "react-image-fallback";
import moment from "moment";
import Paypal from "./Payments/Paypal.component";
import { Modal } from 'react-bootstrap';
import Cookies from "js-cookie";

import defaultUser from '../assets/images/default_profile_pic.jpg';

export default function HeaderNotification(props) {

  let navigate = useNavigate();

  // *************************************************************************
  // Local State
  const [notifications, setNotifications] = useState("");
  const [currentPost, setCurrentPost] = useState("");
  
  // react-bootstrap
  const [show, setShow] = useState(false);
  const [isPaid, setisPaid] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  // *************************************************************************
  // Redux State
  const token = useSelector((state) => state.auth.token);
  const userData = useSelector((state) => state.auth.data);


  // *************************************************************************
  useEffect(() => {
    const getAllNotifications = async () => {
      // ${process.env.REACT_APP_BASE_URL}/api/notifications?user_id=${userData.id}
      await fetch(`${process.env.REACT_APP_BASE_URL}/api/notifications?user_id=${userData?.id}`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((r) => r.json())
        .then((response) => {
          if (response.success && response.records.data.length > 0) {
            let ntf = response?.records?.data?.slice(0, 3);
            setNotifications(ntf);
          } else {
            // console.log(response);
          }
        });
    };
    getAllNotifications();
  }, [token]);

    // *************************************************************************
    // handle payment popup 
    const handlePaymentCheck = (e, post) => {
      e.preventDefault();
      if (Object.keys(post.details).length > 0) {
        setCurrentPost(post.details);        
        if (userData?.role == 3 && post.details.customer_id == userData?.id) {
          <Navigate to={`/jobs/${post?.details.id}`} replace />
          return navigate(`/jobs/${post?.details.id}`, { replace: true });
        }
        else {
          // isPaid ? 
          // navigate(`/jobs/${post?.id}`, { replace: true }) :
          if (post.details.id == Cookies.get(`jobid${post.details.id}`) && Cookies.get(`isPaid${post.details.id}`) == "paid") {
            // console.log("job id Found & user is paid");
            navigate(`/jobs/${post?.details.id}`, { replace: true })
          } else if (post.details.assign_post !== null) {
            Object.keys(post.details.assign_post).length > 0 && post.details.assign_post.user_id === userData?.id &&
              navigate(`/jobs/${post?.details.id}`, { replace: true })
          } else {
            handleShow();
          }
        }
      } else {
        props.setMessage({ id: post.id, msg:`Job Not Found or it has been deleted`});
      }
    };

    // *************************************************************************
  return (
    <>
      {notifications ?
        notifications
        .map((item, idx) => (           
            <Link to="#" onClick={(e) => handlePaymentCheck(e, item)} key={idx}>            
              <div className="notification-item">                
                <div className="notification-item-content">
                  <h6>{item?.notification_text}</h6>
                  <p>
                  {item?.details?.title}
                  </p>
                  <p>
                    <small><em>{moment(item?.created_at).format("MMMM Do YYYY")}</em></small>
                  </p>
                </div>
              </div>
          </Link>
        ))
        : <p className="text-center text-muted my-4">No Notification Found</p>
      }

        
      {/* <!-- Modal --> */}
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header className="border-0" closeButton></Modal.Header>
        <Modal.Body className="p-4">
          <h3>Please Pay to Bid on this Project</h3>
          <Paypal
            job={currentPost}
            redirectURL={`/jobs/${currentPost?.id}`}
            setisPaid={setisPaid}
            handleClose={handleClose}
          />
        </Modal.Body>
      </Modal>
    </>
  );
}
